import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'

import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'

import { howItWorksStyles, Section, Steps, Subtitle, SubtitleWrapper, Title } from './KeepsakeHowItWorks.style'
import { STEP_IMAGE_RATIO, STEP_MOBILE_IMAGE_RATIO } from './Keepsakes.constants'
import Phrases from './Phrases'

const KeepsakeHowItWorks = ({ classes, title, subtitle, steps, children, ...rest }) => {
  const phraseSteps = useMemo(
    () =>
      steps.map((step) => ({
        ...step,
        ...(typeof step.title === 'string' && { title: <Phrases text={step.title} /> }),
        ...(step.narrowTitle && { classes: { title: classes.narrowStepTitle } }),
      })),
    [steps, classes.narrowStepTitle],
  )
  const isMobile = useMobileBreakpoint()

  return (
    <Section
      title={
        <Title variant='h2' align='center'>
          <Phrases text={title} />
        </Title>
      }
      subtitle={
        <SubtitleWrapper>
          <Subtitle variant='subtitle1' align='center'>
            {subtitle}
          </Subtitle>
        </SubtitleWrapper>
      }
      {...rest}
    >
      <Steps steps={phraseSteps} imageRatio={isMobile ? STEP_MOBILE_IMAGE_RATIO : STEP_IMAGE_RATIO} />
      {children}
    </Section>
  )
}

KeepsakeHowItWorks.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  children: PropTypes.node,
}

export default withStyles(howItWorksStyles)(KeepsakeHowItWorks)
